import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { I18nProvider } from "./i18n/I18nContext";
import { Layout } from "./components/layout/Layout";
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import SMARTechsPage from "./pages/SMARTechsPage";
import TrainingsPage from "./pages/TrainingsPage";
import ImpactPage from "./pages/ImpactPage";
import NewsPage from "./pages/NewsPage";
import ContactPage from "./pages/ContactPage";

function App() {
  return (
    <I18nProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/smartechs" element={<SMARTechsPage />} />
            <Route path="/trainings" element={<TrainingsPage />} />
            <Route path="/impact" element={<ImpactPage />} />
            <Route path="/news" element={<NewsPage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </I18nProvider>
  );
}

export default App;
